export default "__VITE_ASSET__DIe83QDX__"